import { ModelsNews } from '@/api/generated-api'

/**
 * A curated placement: the admin stores an ordered list of them, and the public
 * endpoints embed the article. Both the home-screen block and the news hero are
 * fed this way, so the selection rule lives in one place.
 */
export interface NewsPlacementLike {
  index_position?: number
  news?: ModelsNews
}

/**
 * Curated articles in the order an editor put them. Positions are ordering
 * hints rather than addresses — the admin has held 1, 2, 2, 4 for three
 * cards — so the list is sorted and cut to length, never indexed by position.
 * Inactive articles drop out: an unpublished one must not reappear through a
 * placement.
 */
export function selectPlacementNews(
  placements: NewsPlacementLike[] | undefined,
  limit: number
): ModelsNews[] {
  return (placements ?? [])
    .filter(
      (placement): placement is NewsPlacementLike & { news: ModelsNews } =>
        Boolean(placement.news) && placement.news?.is_active !== false
    )
    .slice()
    .sort((a, b) => (a.index_position ?? 0) - (b.index_position ?? 0))
    .slice(0, limit)
    .map(placement => placement.news)
}
